var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSort = function SvgIcSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.759 7.51c-.457 0-.826-.457-.826-1.01 0-.553.36-1 .826-1h16.349c.456 0 .825.447.825 1 0 .553-.369 1.01-.825 1.01H4.758Zm1.817 5.5c-.456 0-.825-.467-.825-1.01 0-.553.36-1.01.825-1.01h12.75c.465 0 .825.446.825 1.01 0 .553-.369 1.01-.826 1.01H6.576ZM8.36 18.5c-.466 0-.826-.457-.826-1.01 0-.554.36-1 .826-1h9.184c.465 0 .825.446.825 1 0 .553-.36 1.01-.825 1.01H8.359Z",
    fill: "#828C97"
  })));
};
export default SvgIcSort;